// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__21zrz","label":"SetPasswdForm_label__2rRj4"};